import path from 'utils/path';

import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/facility',
  link: '/general/facility',
  goCustom: ({ facilityId, region, classification, facilityName }) =>
    path(facilityId, `/custom-classes/?classification=${classification}&region=${region}&facilityName=${facilityName}`),
  goLicensed: ({ facilityId, region, facilityName }) =>
    path(facilityId, `/licensed-classes/?region=${region}&facilityName=${facilityName}`),
  goInstructors: (id) => path(id, '/instructors'),
  goSchedule: ({ facilityId, owner }) => path(facilityId, `/schedule/?owner=${owner}`),
  goPurchase: (facilityId) => path(facilityId, '/purchase'),
};

export const getColumns = ({ purchasePage, editItem, deleteItem }) => {
  const generateActions = () => {
    const defaultActions = [
      { id: 2, name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
      // { id: 3, name: 'Licensed', action: licensedPage, icon: 'mdi:text-box-multiple-outline' },
      // { id: 4, name: 'Custom', action: customPage, icon: 'mdi:text-box-multiple-outline' },
    ];

    if (checkAccess([0, 1, 2])) {
      return [
        {
          id: 1,
          name: 'Delete',
          action: deleteItem,
          icon: 'eva:trash-2-outline',
          sx: { color: 'error.main' },
        },
        {
          id: 'purchase',
          name: 'Purchase',
          action: purchasePage,
          icon: 'mdi:text-box-multiple-outline',
          ignore(item) {
            return item.classification !== 'Gym';
          },
        },
        ...defaultActions,
      ];
    }

    return defaultActions;
  };

  return [
    // { id: 'classification', label: 'Classification', align: 'left', sx: { textTransform: 'capitalize' } },
    { id: 'yfcAllocation', label: 'Allocation', align: 'left', sx: { textTransform: 'capitalize' } },
    { id: 'active', label: 'Active', align: 'center', type: 'boolean' },
    { id: 'name', label: 'Name', align: 'left' },
    { id: 'group', label: 'Group', align: 'center' },
    { id: 'region', label: 'Region', align: 'center', width: 50 },
    { id: 'city', label: 'City', align: 'center' },
    { id: 'address', label: 'Location', align: 'center', width: 200 },
    { id: 'types', label: 'Types', align: 'center', width: 200, sx: { fontSize: 10 } },
    // {
    //   id: 'instructors',
    //   label: 'Instructors',
    //   action: instructors,
    //   icon: 'mdi:dumbbell',
    //   align: 'center',
    //   width: 100,
    //   disableSort: true,
    // },
    // {
    //   id: 'classSchedule',
    //   label: 'Schedule',
    //   action: schedule,
    //   icon: 'mdi:calendar-month',
    //   width: 100,
    //   disableSort: true,
    //   align: 'center',
    // },
    {
      id: 'more-menu',
      type: 'menu',
      items: generateActions(),
      disableSort: true,
    },
  ];
};

export const getFilters = ({ yfcAllocation, active, group, city, searchByName, country, type, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by name...',
    action: searchByName.change,
  },
  {
    id: 'yfcAllocation',
    type: 'select',
    label: 'Allocation',
    value: yfcAllocation.value,
    action: yfcAllocation.change,
    items: options?.yfcAllocation ? ['all', ...options.yfcAllocation] : ['all'],
  },
  {
    id: 'active',
    type: 'select',
    label: 'Active',
    value: active.value,
    action: active.change,
    items: ['all', 'true', 'false'],
  },
  // {
  //   id: 'classification',
  //   type: 'select',
  //   label: 'Classification',
  //   value: 'Gym',
  //   // value: classification.value,
  //   action: classification.change,
  //   items: options?.classification ? ['all', ...options.classification] : ['all'],
  //   disabledEdit: true,
  // },
  {
    id: 'group',
    type: 'select',
    label: 'Group',
    value: group.value,
    action: group.change,
    items: options?.classification ? ['all', ...options.group] : ['all'],
  },
  {
    id: 'city',
    type: 'select',
    label: 'City',
    value: city.value,
    action: city.change,
    items: options?.city ? ['all', ...options.city] : ['all'],
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : country.value,
    action: country.change,
    items: options?.region ? ['all', ...options.region] : ['all'],
    disabledEdit: checkAccess([2]),
  },
  {
    id: 'type',
    type: 'select',
    label: 'Type',
    value: type.value,
    action: type.change,
    items: options?.type ? ['all', ...options.type] : ['all'],
  },
];
